// @ts-ignore
import { DUMMY_BASE_URL, setSearchParams } from '@redhat-cloud-services/javascript-clients-shared/dist/common';
const isServicesGetObjectParams = (params) => {
    const l = params.length === 1;
    if (l && typeof params[0] === 'object' && !Array.isArray(params[0])) {
        return true;
    }
    return false;
};
/**
*
* @summary get a list of services a user is entitled to
* @param {ServicesGetParams} config with all available params.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export const servicesGetParamCreator = async (sendRequest, ...config) => {
    const params = isServicesGetObjectParams(config) ? config[0] : ['options'].reduce((acc, curr, index) => ({ ...acc, [curr]: config[index] }), {});
    const { options = {} } = params;
    const localVarPath = `/services`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    const localVarRequestOptions = { method: 'GET', ...options };
    const localVarHeaderParameter = {};
    const localVarQueryParameter = {};
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    localVarRequestOptions.headers = { ...localVarHeaderParameter, ...options.headers };
    const args = {
        urlObj: localVarUrlObj,
        options: localVarRequestOptions,
    };
    return sendRequest(Promise.resolve(args));
};
export default servicesGetParamCreator;
//# sourceMappingURL=index.js.map